import { render, staticRenderFns } from "./insertCost.vue?vue&type=template&id=18e1677d&"
import script from "./insertCost.vue?vue&type=script&lang=js&"
export * from "./insertCost.vue?vue&type=script&lang=js&"
import style0 from "./insertCost.vue?vue&type=style&index=0&id=18e1677d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports